/* components/AntrenorEntry.jsx */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SUBMENU } from "../utils/constants";
import CoachDashboard from "../pages/CoachDashboard";   // ↖ pune numele real al paginii

export default function AntrenorEntry() {
  const navigate  = useNavigate();
  const location  = useLocation();

  /* ───── tab implicit = primul din SUBMENU.coach ───── */
  const defaultTab = SUBMENU.coach[0].slug;            // "dashboard"

  useEffect(() => {
    const params       = new URLSearchParams(location.search);
    const orgParam     = params.get("org");            // slug organizație
    const coachParam   = params.get("antrenor");       // id user (coach)
    const tabParam     = params.get("tab");            // slug tab curent

    const validTabs    = SUBMENU.coach.map(i => i.slug);

    /* recuperează fallback-urile din session */
    const session      = JSON.parse(localStorage.getItem("session") || "{}");
    const orgFromSess  = session?.organization?.organization_slug || "";
    const coachFromSess= session?.user?.id || "";

    /* verificăm lipsuri / valori invalide */
    const needOrg   = !orgParam   || orgParam.trim()   === "";
    const needCoach = !coachParam || coachParam.trim() === "";
    const needTab   = !tabParam   || !validTabs.includes(tabParam);

    if (needOrg || needCoach || needTab) {
      const finalOrg   = needOrg   ? orgFromSess   : orgParam;
      const finalCoach = needCoach ? coachFromSess : coachParam;
      const finalTab   = needTab   ? defaultTab    : tabParam;

      /* redirecție cu replace (fără a adăuga istoric în plus) */
      navigate(
        `/antrenor?org=${finalOrg}&antrenor=${finalCoach}&tab=${finalTab}`,
        { replace: true }
      );
    }
  }, [location.search, navigate]);

  /* URL este deja valid → afișăm dashboard-ul coach-ului */
  return <CoachDashboard />;
}
